export default "__VITE_ASSET__BcxHOnwC__"